/* GENERATED by tools/dc-port from design-reference/PointFive OS Original.dc.html — DOM-faithful view.
 * Do not hand-edit layout/style literals; regenerate with `pnpm --filter @pointfive/dc-port port`. */
import * as dc from '@/lib/dc';
import type { ViewModel } from './view-model';

export function StubView({ m }: { m: ViewModel }) {
  return (
    <>
      {' '}
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100%',
          padding: '40px',
        }}
      >
        <div style={{ textAlign: 'center', color: 'var(--muted)' }}>
          <i className={`ph ${dc.s(m.stubIcon)}`} style={{ fontSize: '34px', color: 'var(--ghost)' }}></i>
          <div style={{ marginTop: '10px', fontSize: '13px', color: 'var(--text-mid)' }}>
            {dc.t(m.stubTitle)}
          </div>
          <div style={{ fontSize: '11.5px', color: 'var(--muted)', marginTop: '4px' }}>
            Not built yet — say the word and I'll design this screen.
          </div>
        </div>
      </div>{' '}
    </>
  );
}
